import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from "@/components/ui/accordion";
import { FAQS } from "@/data/content";
import { Reveal, LineReveal } from "./motion/Reveal";
import { scrollToId } from "@/lib/scroll";

export const FAQ = () => (
  <section id="faq" data-testid="faq-section" className="section-y bg-ivory">
    <div className="container-x grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
      <div className="lg:col-span-4">
        <div className="lg:sticky lg:top-32">
          <Reveal><p className="eyebrow mb-6">FAQ</p></Reveal>
          <LineReveal inView as="h2" lines={["Questions,", <><span className="italic text-sage">answered.</span></>]} className="h2" />
          <Reveal delay={0.2} className="body-lg mt-8">Everything you might want to know before we begin. If your question isn't here, we're a message away.</Reveal>
          <Reveal delay={0.3}><button data-testid="faq-cta" onClick={() => scrollToId("contact")} className="btn btn-outline mt-8"><span>Talk to Amara Studios</span></button></Reveal>
        </div>
      </div>
      <Reveal className="lg:col-span-8">
        <Accordion type="single" collapsible className="border-t border-taupe-line">
          {FAQS.map((f, i) => (
            <AccordionItem key={i} value={`q${i}`} data-testid={`faq-accordion-item-${i + 1}`} className="border-b border-taupe-line">
              <AccordionTrigger data-testid={`faq-trigger-${i + 1}`} className="py-6 lg:py-7 hover:no-underline text-left gap-6 [&>svg]:h-5 [&>svg]:w-5 [&>svg]:text-sage [&>svg]:shrink-0 group">
                <span className="flex items-baseline gap-5">
                  <span className="font-mono text-[10px] tracking-[0.2em] text-taupe">{String(i + 1).padStart(2, "0")}</span>
                  <span className="font-serif text-xl sm:text-2xl lg:text-[1.75rem] font-light text-charcoal leading-snug transition-colors group-hover:text-sage">{f.q}</span>
                </span>
              </AccordionTrigger>
              <AccordionContent className="pb-7 pl-[3.1rem] pr-10 text-sm sm:text-[15px] text-ink/70 font-light leading-relaxed">{f.a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);
